<template>
  <div>
    <div>
      <div v-if="loading" class="text-center" style="margin-top: 88px">
        <Loading></Loading>
      </div>
      <v-container
        v-else
        class="Kanit px-5"
        grid-list-xs
        style="padding-bottom: 100px"
      >
        <div style="text-align: center; position: relative" class="py-2 mb-3">
          <div
            v-if="$store.state.redirect"
            style="position: absolute; top: 0px; left: 0px"
          >
            <v-btn
              @click="query.view = $store.state.redirect"
              text
              class="pl-0"
            >
              <v-icon class="mr-2">mdi-chevron-left</v-icon>BACK
            </v-btn>
          </div>
          <img style="height: 50%; width: 64px" src="../assets/logo.svg" />
        </div>
        <choose-address
          :proploading="saveloading"
          @onSubmitButton="confirmAddress"
        ></choose-address>
      </v-container>
    </div>
    <v-dialog
      v-model="showTaxDialog"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card class="pa-3">
        <div>
          <AddressTaxForm
            @saveTax="onSaveTax"
            @close="showTaxDialog = false"
            v-if="showTaxDialog"
          ></AddressTaxForm>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ChooseAddress from "./ChooseAddress.vue";
import AddressTaxForm from "./AddressTaxForm.vue";
import Loading from "@/components/Loading.vue";
import axios from "axios";
export default {
  components: { ChooseAddress, Loading, AddressTaxForm },
  computed: {
    address() {
      return this.$store.state.address;
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    isCustomerProfile() {
      return this.$store.state.redirect == "CustomerProfile" ? true : false;
    },
  },
  data() {
    return {
      loading: true,
      showTaxDialog: false,
    };
  },
  async mounted() {
    this.$store.state.registerType == "customer";
    await this.getProducts();
    await this.checkLoginStatus();
    if (!this.$store.state.statuslogin) {
      await this.checkRegisterStatus();
    }
    await this.getUserAddress();
    this.loading = false;
  },
  methods: {
    onSaveTax(taxinput) {
      this.$store.state.taxloading = true;
      this.submitAddress(taxinput);
    },
    getUserAddress() {
      var vm = this;
      return new Promise((resolve, reject) => {
        var url = "";
        if (vm.$store.state.redirect == "DealerProfile" && false) {
          url = "toadealeraddress";
        } else {
          url = "toainfocustomer";
        }

        axios
          .get("https://communitybotbyzwizai.herokuapp.com/" + url, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: {
              userid: vm.$store.state.userid,
              apptype: vm.query.apptype,
              pageid: vm.query.pageid,
            },
          })
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              return;
            } else if (
              response.data.responsecode == 200 &&
              response.data.data
            ) {
              if (response.data.data) {
                this.$store.state.address = response.data.data[0].address;
                var defaultAddress = this.address.find((el) => el.is_default);
                this.$store.state.activeAddress = defaultAddress
                  ? defaultAddress.id
                  : "";
              } else {
              }
            }
            resolve();
          });
      });
    },
    checkRegisterStatus() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckusersregister",
            {
              params: {
                userid: vm.$store.state.userid,
                apptype: vm.query.apptype,
                pageid: vm.query.pageid,
              },
              headers: {
                AUTHORIZATION: "Bearer xxx xxx ",
              },
            }
          )
          .then(async (response) => {
            if (response.data && response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              return;
            } else if (response.data.responsecode == 200) {
              if (response.data.data[0].status) {
                //เคยสมัคร
                vm.$store.state.statusregister = true;
                vm.$store.state.redirect = "CustomerAddress";
                vm.query.view = "Agreement";
                resolve();
              } else {
                vm.$store.state.statusregister = true;
                if (!vm.$store.state.viewAfterAgreement) {
                  vm.$store.state.viewAfterAgreement = "CustomerAddress";
                  vm.query.view = "Agreement";
                  vm.loading = false;
                  resolve();
                } else {
                  vm.$store.state.isNewUser = true;
                  vm.newAddressBtn();
                  vm.loading = false;
                  resolve();
                }
              }
            }
          });
      });
    },
    checkLoginStatus() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toacheckstatuslogincustomer",
            {
              headers: { AUTHORIZATION: "Bearer xxx xxx" },
              params: {
                userid: vm.$store.state.userid,
                apptype: vm.query.apptype,
                pageid: vm.query.pageid,
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 400) {
              vm.$store.state.statuslogin = false;
              resolve();
              //
            } else {
              vm.$store.state.statuslogin = true;
              resolve();
            }
          });
      });
    },
    getProducts() {
      var vm = this;
      return new Promise((resolve) => {
        axios
          .get("https://communitybotbyzwizai.herokuapp.com/toacarts", {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
            params: {
              userid: vm.$store.state.userid,
              apptype: vm.query.apptype,
              pageid: vm.query.pageid,
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) resolve();
            else if (response.data.responsecode == 400) {
              await vm.$swal.fire({
                text: response.data.reason,
              });
              if (vm.query.apptype == "line") {
                await vm.$liff.closeWindow();
              } else if (vm.query.apptype == "facebook") {
                vm.$store.dispatch("messengerClose");
              }
            }
          });
      });
    },
    async confirmAddress() {
      var vm = this;

      if (!vm.saveloading) {
        var result = await vm.$swal.fire({
          icon: "question",
          text: "ต้องการใบกำกับภาษีหรือไม่",
          showCancelButton: true,
          confirmButtonText: "ต้องการ",
          cancelButtonText: "ไม่ต้องการ",
          showCloseButton: true,
        });
        if (result.value || result.dismiss == "cancel") {
          if (result.dismiss == "cancel") {
            this.submitAddress();
          } else {
            this.showTaxDialog = true;
          }
        }
      }
    },
    async submitAddress(tax = null) {
      var vm = this;
      this.saveloading = true;
      var address = this.$store.state.address.find(
        (el) => el.id == this.$store.state.activeAddress
      );
      var data = {
        userid: vm.$store.state.userid,
        apptype: vm.query.apptype,
        pageid: this.query.pageid,
        address: address,
        tax: tax,
      };
      axios
        .post(
          "https://communitybotbyzwizai.herokuapp.com/toainfocustomer",
          data,
          {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          }
        )
        .then(async (response) => {
          this.saveloading = false;
          if (response.data && response.data.responsecode == 400) {
            await this.$swal.fire({
              icon: "error",
              text: response.data.reason,
              confirmButtonText: "ตกลง",
            });
            return;
          } else if (response.data.responsecode == 200 && response.data.data) {
            if (this.query.apptype == "line") {
              await this.$liff.closeWindow();
            } else if (this.query.apptype == "facebook") {
              this.$store.dispatch("messengerClose");
            }
          } else {
            vm.$swal.fire({
              icon: "error",
              text: "ลงทะเบียนไม่สำเร็จ",
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>